import { render, staticRenderFns } from "./epb-facets-aside.component.vue?vue&type=template&id=24dce687&scoped=true"
import script from "./epb-facets-aside.component.vue?vue&type=script&lang=ts"
export * from "./epb-facets-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-facets-aside.component.vue?vue&type=style&index=0&id=24dce687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dce687",
  null
  
)

export default component.exports